import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
// Контактные данные
const PHONE_NUMBER = '380508399309';
const TELEGRAM_LINK = `https://t.me/+${PHONE_NUMBER}`;
const WHATSAPP_LINK = `https://wa.me/${PHONE_NUMBER}`;
const EMAIL = 'maximtovkach98@gmail.com';
export function Footer() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  const handleInternalLink = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
  };
  return <footer className="w-full py-12 sm:py-16 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-144" data-mp="398xsbsbb070">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145" data-mp="3qdf7jfucjgev">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-146" data-mp="3qblwzpgm4c1l">
          <div className="flex items-center gap-2" data-id="element-147" data-mp="29xlzel58oyhi">
            <span className="text-lg sm:text-xl font-bold tracking-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-148" data-mp="2ey0ayd61uqka">
              Linkery
            </span>
          </div>
          <div className="flex items-center gap-6" data-id="element-149" data-mp="3gc0g7grppo61">
            <a href={getPath('privacy')} onClick={e => handleInternalLink(e, 'privacy')} className="text-sm hover:underline" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-150" data-mp="3v7ggi3ivygav">
              {t('nav.privacy')}
            </a>
            <div className="text-xs sm:text-sm text-center" style={{
            color: 'var(--text-muted)'
          }} data-id="element-151" data-mp="34p997szhui9">
              © {new Date().getFullYear()} Linkery. {t('footer.rights')}
            </div>
          </div>
        </div>
      </div>
    </footer>;
}